import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome } from '@fortawesome/free-solid-svg-icons';
import styled from 'styled-components';
import bannerbg from '../../Images/bannerbg.png'

const ServicesBanner = () => {
    return (
        <div>
            <Container img={bannerbg}>
                <h2>Services</h2>
                <div className="path">
                    <FontAwesomeIcon
                        icon={faHome}
                    />
                    <h5>Home <span>/ Services</span></h5>
                </div>
            </Container>
        </div>
    )
}

export default ServicesBanner


const Container = styled.div`
    display: flex;
    flex-direction: column;
    color: white;
    align-items: center;
    justify-content: center;
    height: 60vh; 
    /* position: absolute;
    top: 0; */
    /* background: red; */
    width: 100%;
    background-image: linear-gradient(rgba(0, 2, 25, 0.9), rgba(0, 2, 25, 0.9)), url(${props => props.img});
    background-repeat: no-repeat;
    background-size: cover;
    background-position: 50%;
    overflow: hidden;
    h2{
        font-size: 2.4rem;
        padding: 1rem;
        color: #fff;
        font-weight: 800;
    }
    .path{
        display: flex;
        flex-direction: row;
        font-size: 1.2rem;
        span{
            color: #E21F36;
        }
    }
`